import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-port-answer',
  templateUrl: './port-answer.component.html',
  styleUrls: ['./port-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PortAnswerComponent {}
